import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {Table} from 'antd';

import YesNoDialog from '../../component/YesNoDialog';

import { Enquiry } from '../../model/enquiry';
import TransactionState from '../../model/TransactionState';

import './ConfirmRetryDialog.less';

//
// Confirm the creation of a medical booking
//

const ACTION_NOTIFY = 'NOTIFY';

const ConfirmRetryDialog: FC<{
  onExit: (response: boolean) => void,
  open: boolean,
  enquiry: Enquiry | null,
  action: string,
  notification: string | null,
  medicalExam: TransactionState | null,
  forMedicalExam: boolean
}> = ({
  onExit, open, enquiry, action, notification, medicalExam, forMedicalExam
}) => {
  const { t } = useTranslation();

  const medicalExamColumns: any[] = [
    {
      title: t('retry.enquiry.dialog.medical.exam.table.lastUpdated'),
      dataIndex: 'updated',
      render: (updated: Date, medicalExam: TransactionState) => updated?.toLocaleDateString()
    },
    {
      title: t('retry.enquiry.dialog.medical.exam.table.evidenceRequested'),
      dataIndex: 'evidenceRequested',
    },
    {
      title: t('retry.enquiry.dialog.medical.exam.table.evidenceProvider'),
      dataIndex: 'evidenceProvider',
    },
    {
      title: t('retry.enquiry.dialog.medical.exam.table.status'),
      dataIndex: 'bookingStatus',
    },
  ];

  return (
    <YesNoDialog title={t('confirm.retry.dialog.title')} onExit={onExit} open={open}>
      {t('confirm.retry.dialog.text')}
      <table className="confirm-retry-dialog-table">
        <tbody>
        <tr>
          <th>{t('retry.enquiry.dialog.applicationId')}</th>
          <td>{enquiry?.applicationId}</td>
        </tr>
        <tr>
          <th>{t('retry.enquiry.dialog.enquiryId')}</th>
          <td>{enquiry?.enquiryId}</td>
        </tr>
        <tr>
          <th>{t('retry.enquiry.dialog.name')}</th>
          <td>{enquiry?.firstName} {enquiry?.surname}</td>
        </tr>
        <tr>
          <th>{t('retry.enquiry.dialog.action.title')}</th>
          <td>{t('retry.enquiry.dialog.action.' + action)}</td>
        </tr>
        { action === ACTION_NOTIFY &&
            <tr>
              <th>{t('retry.enquiry.dialog.notification.title')}</th>
              <td>{t('retry.enquiry.dialog.notification.' + notification)}</td>
            </tr>
        }
        </tbody>
      </table>
      {(forMedicalExam && medicalExam) && <>
          <h3>{t('retry.enquiry.dialog.medical.exam.title')}</h3>
          <table className="confirm-retry-dialog-table">
            <tbody>
              <tr>
                <th>{t('retry.enquiry.dialog.transactionId')}</th>
                <td>{medicalExam.transactionId}</td>
              </tr>
            </tbody>
          </table>
          <Table
              columns={medicalExamColumns}
              dataSource={[medicalExam]}
              rowKey="transactionId"
              pagination={false}
          />
      </>}
    </YesNoDialog>
  );
};

export default ConfirmRetryDialog;
